import { render } from "./addAdmin.vue?vue&type=template&id=9f457e52&scoped=true"
import script from "./addAdmin.vue?vue&type=script&lang=js"
export * from "./addAdmin.vue?vue&type=script&lang=js"

import "./addAdmin.vue?vue&type=style&index=0&id=9f457e52&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f457e52"]])

export default __exports__